import { SectionNames } from '@/analytics/sectionNames';
import { performVWBasicButtonClick } from '@/analytics/events';
import { useTribalContext } from '@/context/tribal';
import useGlobalStore, {
  GlobalStoreStateConfiguration,
} from '@/stores/globalStore';
import { getActiveConfiguration } from '@/modules/utils/storeUtils';
import {
  DesignTokenSizeEnum,
  TokenTextColor,
  TokenTextAppearance,
  CTA,
  Text,
  Image,
  WhiteSpace,
  TextAlignment,
} from '@volkswagen-onehub/components-core';
import { Box } from '@tribal-worldwide-london/ui-component-library-vwg';
import { isMobile } from '@/modules/utils/breakpoints';
import useResizeResponsive from '@/hooks/useResizeResponsive';

function YourWagenBanner() {
  const { contentManager, analyticsManager, analyticsBuilder } =
    useTribalContext();
  const { retailers, configurations } = useGlobalStore((state) => state.app);
  const { app } = useGlobalStore();
  const activeConfiguration: GlobalStoreStateConfiguration | undefined =
    getActiveConfiguration(app);

  const isMobileWidth = useResizeResponsive(isMobile);
  const showBanner = contentManager.get('yourwagen-banner-enabled');

  const eventBannerLinkUrl = contentManager.get('yourwagen-banner-link-url');
  const eventBannerLinkText = contentManager.get('yourwagen-banner-link-text');
  const eventBannerTitle = contentManager.get('yourwagen-banner-title');
  const eventBannerContent = contentManager.get('yourwagen-banner-content');
  const eventBannerImageUrl = contentManager.get('yourwagen-banner-image-url');
  const eventBannerImageAlt = contentManager.get('yourwagen-banner-image-alt');
  const eventBannerBackgroundImageUrl = contentManager.get(
    'yourwagen-banner-background-image'
  );

  const onClickHandler = () => {
    window.open(eventBannerLinkUrl, '_blank');
    performVWBasicButtonClick({
      label: eventBannerLinkText,
      sectionName: SectionNames.EVENT_BANNER,
      configuration: activeConfiguration,
      retailers,
      analyticsManager,
      analyticsBuilder,
    });
  };

  if (showBanner === 'false') return;

  return (
    <div
      style={{
        backgroundImage: `url(${eventBannerBackgroundImageUrl})`,
        backgroundPosition: 'bottom',
        backgroundColor: 'white',
        paddingBottom: isMobileWidth ? '120px' : '100px',
        paddingTop: isMobileWidth ? '64px' : '80px',
      }}
    >
      <Box
        display="flex"
        flexDirection={isMobileWidth ? 'column' : 'row'}
        alignItems={'center'}
        justifyContent={'center'}
        gap={
          isMobileWidth
            ? DesignTokenSizeEnum.dynamic0200
            : DesignTokenSizeEnum.static1000
        }
      >
        <div>
          <div>
            <Image src={eventBannerImageUrl} alt={eventBannerImageAlt} />
          </div>
        </div>
        <Box
          flex="true"
          flexDirection="column"
          gap={DesignTokenSizeEnum.static300}
          maxWidth={isMobileWidth ? '90%' : '50%'}
        >
          <Text
            color={TokenTextColor.primary}
            appearance={TokenTextAppearance.headline300}
            bold
            textAlign={
              isMobileWidth ? TextAlignment.center : TextAlignment.left
            }
          >
            {eventBannerTitle}
          </Text>
          <Box
            marginTop={DesignTokenSizeEnum.dynamic0100}
            marginBottom={DesignTokenSizeEnum.dynamic0100}
          >
            <Text
              color={TokenTextColor.primary}
              appearance={TokenTextAppearance.bigcopy100}
              whiteSpace={WhiteSpace.preWrap}
              textAlign={
                isMobileWidth ? TextAlignment.center : TextAlignment.left
              }
            >
              {eventBannerContent}
            </Text>
          </Box>
          <div style={{ textAlign: isMobileWidth ? 'center' : 'left' }}>
            <CTA
              tag="button"
              emphasis="primary"
              onClick={onClickHandler}
              aria-label={eventBannerLinkUrl}
            >
              {eventBannerLinkText}
            </CTA>
          </div>
        </Box>
      </Box>
    </div>
  );
}

export default YourWagenBanner;
